import { Navigate } from 'react-router-dom'

export function IntelligenceHub() {
  return <Navigate to="/intelligence/assets" replace />
}
